export default __webpack_public_path__ + "static/MarriageBanner-e30a3dcb10ff008f23c81e4caf871c65.png";